/**
 * Scales (balance) icon for QA evidence
 * Story 288: View QA evidence for completed stories
 *
 * SVG scales icon representing justice/balance, used to indicate
 * QA evidence is available for review.
 */

interface ScalesIconProps {
  /** Icon size in pixels (default: 16) */
  size?: number;
  /** Additional CSS class */
  className?: string;
}

export function ScalesIcon({ size = 16, className }: ScalesIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Central pillar */}
      <line x1="12" y1="3" x2="12" y2="21" />
      {/* Balance beam */}
      <line x1="4" y1="7" x2="20" y2="7" />
      {/* Left scale pan */}
      <path d="M4 7 L2 15 L6 15 Z" />
      {/* Right scale pan */}
      <path d="M20 7 L18 15 L22 15 Z" />
      {/* Base */}
      <line x1="8" y1="21" x2="16" y2="21" />
    </svg>
  );
}
